var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeEngagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 245,
    fill: "#fac600",
    opacity: 1,
    "data-original": "#314dc9",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.936,
    cy: 278.921,
    r: 200,
    fill: "#8783d1",
    opacity: 1,
    "data-original": "#4f66d0",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#26a6fe",
    d: "M360.643 243.814c-6.248-6.248-6.248-16.379 0-22.627l69.208-69.208a5.836 5.836 0 0 0 0-8.255l-13.41-13.41c-6.248-6.248-16.379-6.248-22.627 0l-36.476 36.476c-3.475-3.276-8.37-5.06-13.665-4.33-7.199.993-12.997 6.792-13.989 13.99-.73 5.294 1.055 10.189 4.33 13.663l-31.072 31.072c-6.248 6.248-6.248 16.379 0 22.627l25.742 25.742a3.982 3.982 0 0 0 5.328.284c3.282-2.674 7.611-4.11 12.277-3.599 7.578.83 13.705 6.957 14.535 14.535.511 4.667-.926 8.996-3.599 12.277a3.982 3.982 0 0 0 .284 5.328l36.306 36.306c6.248 6.248 16.379 6.248 22.627 0l17.537-17.537z",
    opacity: 1,
    "data-original": "#26a6fe",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01c0fa",
    d: "m429.511 143.384-77.803 77.803c-6.248 6.248-6.248 16.379 0 22.627l77.803 77.803 77.803-77.803c6.248-6.248 6.248-16.379 0-22.627z",
    opacity: 1,
    "data-original": "#01c0fa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ec597",
    d: "M63.336 243.814c-6.248-6.248-6.248-16.379 0-22.627l80.324-80.324-7.681-7.681-17.792-2.867c-6.248-6.248-16.379-6.248-22.627 0L4.686 221.186c-6.248 6.248-6.248 16.379 0 22.627l90.873 90.873c6.248 6.248 16.379 6.248 22.627 0l19.835-10.122 3.032-3.032z",
    opacity: 1,
    "data-original": "#fb8801",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5dd39e",
    d: "m138.942 136.144-85.043 85.043c-6.248 6.248-6.248 16.379 0 22.627l81.89 81.89 2.233-1.139 78.128-78.128 4.224-13.936-3.543-18.468z",
    opacity: 1,
    "data-original": "#fea713",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd5426",
    d: "M172.995 357.314c-6.248-6.248-6.248-16.379 0-22.627l71.191-71.192a5.078 5.078 0 0 0 0-7.181L220.373 232.5 118.186 334.686c-6.248 6.248-6.248 16.379 0 22.627l90.873 90.873c6.248 6.248 16.379 6.248 22.627 0l12.436-12.436a5.169 5.169 0 0 0 0-7.309z",
    opacity: 1,
    "data-original": "#fd5426",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5c2",
    d: "M105 223.416c11.456 0 20.742-9.287 20.742-20.742v-6.914c0-11.456-9.287-20.742-20.742-20.742-11.456 0-20.742 9.287-20.742 20.742v6.914c0 11.456 9.286 20.742 20.742 20.742z",
    opacity: 1,
    "data-original": "#ffe5c2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fd5426",
    d: "M73.457 274.169h63.086a3.457 3.457 0 0 0 3.457-3.457v-17.285c0-11.456-9.287-20.742-20.742-20.742H90.742c-11.456 0-20.742 9.287-20.742 20.742v17.285a3.457 3.457 0 0 0 3.457 3.457z",
    opacity: 1,
    "data-original": "#fd5426",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe5c2",
    d: "M405 223.416c11.456 0 20.742-9.287 20.742-20.742v-6.914c0-11.456-9.287-20.742-20.742-20.742-11.456 0-20.742 9.287-20.742 20.742v6.914c0 11.456 9.286 20.742 20.742 20.742z",
    opacity: 1,
    "data-original": "#ffe5c2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe70d",
    d: "M373.457 274.169h63.086a3.457 3.457 0 0 0 3.457-3.457v-17.285c0-11.456-9.287-20.742-20.742-20.742h-28.515c-11.456 0-20.742 9.287-20.742 20.742v17.285a3.456 3.456 0 0 0 3.456 3.457z",
    opacity: 1,
    "data-original": "#fee903",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed402",
    d: "M173.335 130.314c-6.248-6.248-6.248-16.379 0-22.627l71.16-71.16a4.88 4.88 0 0 0 0-6.904l-12.809-12.808c-6.248-6.248-16.379-6.248-22.627 0l-90.873 90.873c-6.248 6.248-6.248 16.379 0 22.627l35.662 35.662a16.469 16.469 0 0 0-6.115 12.822c0 9.113 7.387 16.5 16.5 16.5 5.177 0 9.797-2.384 12.822-6.115l43.317 43.317 24.08-24.08a4.943 4.943 0 0 0 0-6.99z",
    opacity: 1,
    "data-original": "#fed402",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164.234,
    cy: 288.521,
    r: 16.5,
    fill: "#5dd39e",
    opacity: 1,
    "data-original": "#fea713",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe7701",
    d: "m322.559 334.686-34.24-34.24a16.454 16.454 0 0 0 5.096-11.925c0-9.113-7.387-16.5-16.5-16.5a16.454 16.454 0 0 0-11.925 5.096l-20.905-20.905-78.474 78.474c-6.248 6.248-6.248 16.379 0 22.627l78.474 78.474 78.473-78.474c6.249-6.248 6.249-16.378.001-22.627z",
    opacity: 1,
    "data-original": "#fe7701",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5dd39e",
    d: "M469.277 379.038c0 16.802-4.712 32.504-12.885 45.856a14.484 14.484 0 0 1-4.783 4.783c-13.352 8.174-29.054 12.885-45.856 12.885-48.416 0-87.959-39.542-87.958-87.958 0-16.795 4.708-32.491 12.875-45.84a14.546 14.546 0 0 1 4.809-4.809c13.349-8.167 29.045-12.875 45.84-12.875 48.415-.001 87.958 39.542 87.958 87.958z",
    opacity: 1,
    "data-original": "#05e39c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5cc797",
    d: "M457.215 423.52c-15.279 26.012-43.548 43.475-75.896 43.475-48.578 0-87.957-39.38-87.957-87.957 0-32.348 17.463-60.617 43.475-75.896-7.666 13.051-12.061 28.253-12.061 44.483 0 48.578 39.38 87.957 87.957 87.957 16.229-.001 31.431-4.397 44.482-12.062z",
    opacity: 1,
    "data-original": "#0ed2b3",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2fbff",
    d: "M376.619 420.321a9.966 9.966 0 0 1-7.071-2.929l-36.806-36.805c-3.905-3.905-3.905-10.237 0-14.142 3.906-3.905 10.236-3.906 14.143 0l29.734 29.734 43.989-43.989c3.907-3.905 10.237-3.904 14.143 0 3.905 3.906 3.905 10.237 0 14.143l-51.061 51.06a9.968 9.968 0 0 1-7.071 2.928z",
    opacity: 1,
    "data-original": "#f2fbff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffbd86",
    d: "M215 333.899c11.456 0 20.742-9.287 20.742-20.742v-6.914c0-11.456-9.287-20.742-20.742-20.742-11.456 0-20.742 9.287-20.742 20.742v6.914c0 11.455 9.286 20.742 20.742 20.742z",
    opacity: 1,
    "data-original": "#ffbd86"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffe70d",
    d: "M183.457 384.652h63.086a3.457 3.457 0 0 0 3.457-3.457V363.91c0-11.456-9.287-20.742-20.742-20.742h-28.515c-11.456 0-20.742 9.287-20.742 20.742v17.285a3.456 3.456 0 0 0 3.456 3.457zM322.559 107.686l-78.473-78.474-78.474 78.474c-6.248 6.248-6.248 16.379 0 22.627l78.474 78.474 16.051-16.051c1.321-1.321 1.569-3.392.551-4.958-2.06-3.169-3.061-7.089-2.503-11.259.971-7.252 6.817-13.097 14.069-14.068 4.17-.558 8.09.443 11.259 2.503 1.566 1.018 3.637.77 4.958-.551l34.089-34.089c6.247-6.249 6.247-16.379-.001-22.628z",
    opacity: 1,
    "data-original": "#fee903",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9b58",
    d: "M215 113.899c11.456 0 20.742-9.287 20.742-20.742v-6.914c0-11.456-9.287-20.742-20.742-20.742-11.456 0-20.742 9.287-20.742 20.742v6.914c0 11.455 9.286 20.742 20.742 20.742z",
    opacity: 1,
    "data-original": "#ea9b58",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe7701",
    d: "M183.457 164.652h63.086a3.457 3.457 0 0 0 3.457-3.457V143.91c0-11.456-9.287-20.742-20.742-20.742h-28.515c-11.456 0-20.742 9.287-20.742 20.742v17.285a3.456 3.456 0 0 0 3.456 3.457z",
    opacity: 1,
    "data-original": "#fe7701",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeEngagement);
export default __webpack_public_path__ + "static/media/employee-engagement.12240f8365f8435ff50ec331f6e483de.svg";
export { ForwardRef as ReactComponent };